import { RemotePrice } from "../../usecases";
import { Price } from "../../../domain/usecases";
import { makeApiPriceUrl, makeAxiosHttpClient } from "../http";

export const makeRemotePrice = (): Price =>
  new RemotePrice(makeApiPriceUrl(), makeAxiosHttpClient());
